/* Grey cards in the shape of a listing card (listing-card.module.css): a
   210 px photo over a few lines of text. */
.card {
  border-radius: var(--radius-card);
  overflow: hidden;
  background: var(--card);
  box-shadow: var(--shadow-card);
}

.photo {
  height: 210px;
  background: var(--band);
}

.line {
  height: 12px;
  margin: 18px 18px 0;
  border-radius: 6px;
  background: var(--band);
}

.line:last-child {
  width: 45%;
  margin-bottom: 22px;
}

.card {
  animation: pulse 1.4s ease-in-out infinite;
}

@keyframes pulse {
  50% {
    opacity: 0.55;
  }
}

@media (prefers-reduced-motion: reduce) {
  .card {
    animation: none;
  }
}
